export const FILTER_TYPES = Object.freeze({
  QUERY: "query",
  FLAG: "flag",
  FACET: "facet",
  FACET_PATH: "facet_path",
});

export const FIELD_NAMES = Object.freeze({
  ADDITIONAL_LICENSES: "additional_licenses",
  AUTHORS: "authors",
  BRAND: "brand",
  CLASS_LEVELS: "class-levels",
  COVER_URI: "cover-uri",
  DATE_EXPECTED_PUBLICATION: "date-expected-publication",
  DATE_PUBLICATION: "date-publication",
  DEMO_EXISTS: "demo_exists",
  DESCRIPTION: "description",
  DETAIL_URI: "detail-uri",
  DISPLAY_TITLE_HEADING: "display-title-heading",
  DISPLAY_TITLE_SUBHEADING: "display-title-subheading",
  DISPLAY_TITLE_INFO: "display-title-info",
  EDITION_TITLE: "edition-title",
  EDITORS: "editors",
  EDUCATIONAL_AREAS: "educational-areas",
  FEDERAL_STATES: "federal-states",
  FORM: "form",
  IDENTIFIER: "identifier",
  ISBN: "isbn",
  // Not available atm
  // ISBN_10: 'isbn10',
  // ISBN_FORMATED: 'isbn-formatted',
  IS_ESTIMATED_PRICE: "is-estimated-price",
  IS_FREE_IN_ABO: "is-free-in-abo",
  IS_NEW: "is-new",
  KEYWORD: "keyword",
  KEYWORDS: "keywords",
  LICENSE_FORM: "license-form",
  LICENSE_FORM_SHORT: "license-form-short",
  ORDER_NR: "order-nr",
  PARTNER_ISBN: "partner-isbn",
  PATH_ES: "path-es",
  PATH_ZBAF: "path-zbaf",
  PATH_SSV: "path-ssv",
  PATH_SV: "path-sv",
  PRE_AUTHORS: "pre-authors",
  PRICE_EUR: "price-eur",
  PRODUCTTYPES: "producttypes",
  PRODUCT_LINE: "product-line",
  PUBLISHING_HOUSE: "publishing-house",
  SAL_GUID: "sal-guid",
  SAL_TYPE: "sal-type",
  SCHOOL_SUBJECTS: "school-subjects",
  SCHOOL_TYPES: "school-types",
  SERIES_SUBTITLE: "series-subtitle",
  SERIES_TITLE: "series-title",
  SKU: "sku",
  SUBTITLE: "subtitle",
  SUPPORTED_BY_SERIES: "supported_by_series",
  TITLE: "title",
  TITLETYPE: "titletype",
  TITLETYPE_SUBTITLE: "titletype-subtitle",
  TITLE_FULL: "title-full",
  TITLE_VISUALIZATION_TYPE: "title-visualization-type",
  VOLUME_TITLE: "volume-title",
  TARGET_GROUP_NAME: "target-group-name",
  DISTRIBUTIONSFORM: "distributionsform",
  FORMAT: "format",
  AREA: "area",
  GER_NIVEAU: "ger-niveau",
  PRODUCT_TYPE_SEMANTIC: "product-type-semantic",
});
